import { uiSize } from '@utils'

interface Props {
  color?: string
}

function DepositIcon({ color = 'currentColor' }: Props) {
  return (
    <svg
      width={uiSize(14)}
      height={uiSize(14)}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke={color}
      strokeWidth='2.4'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12 5v14M5 12h14' />
    </svg>
  )
}

export default DepositIcon
